const crossDomainTracking = (domain, gaAccount, isChat) => {
    // removing the leading www if it exists
    domain = domain.replace(/^(www\.)/, '');
    if (isChat) {
        (function (i, s, o, g, r, a, m) {
            i.GoogleAnalyticsObject = r;
            (i[r] =
                i[r] ||
                function () {
                    (i[r].q = i[r].q || []).push(arguments);
                }),
                (i[r].l = 1 * new Date());
            (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

        ga('create', gaAccount, 'auto', { allowLinker: true });
        ga('require', 'linker');
        ga('linker:autoLink', [domain]);
        ga('send', 'event', 'Chats', 'chatStarted');
    } else {
        ga('send', 'event', 'ChatsToLeads', 'converted');
    }
};
export default crossDomainTracking;
